import {useMatches} from '@github-ui/react-router'

import {codeViewBlameRoute} from '../routes/code-view-blame-route'
import {codeViewBlobRoute} from '../routes/code-view-blob-route'
import {codeViewEditRoute} from '../routes/code-view-edit-route'
import {codeViewNewRoute} from '../routes/code-view-new-route'

export function useRouteAction() {
  const matches = useMatches()

  for (const match of matches) {
    if (match.id === codeViewBlameRoute.id) return 'blame'
    if (match.id === codeViewBlobRoute.id) return 'blob'
    if (match.id === codeViewEditRoute.id) return 'edit'
    if (match.id === codeViewNewRoute.id) return 'new'
  }

  return 'tree'
}
